<!--
헤더에 지역/사용자명을 표시하는 네비게이션
-------------------
폰트크기를 em으로 작성하였다.
크기조정하려면, 호출하는쪽에서, 컴포넌트에 font-size style 지정해주면 그 값을 기준으로 내부 폰트 크기가 적용된다.

REF-034 (2026-05-26): REF-020 디자인 원복 — REF-020 commit a115ad9ff 에서 삭제된 옛 컴포넌트 신규 재생성.
원복 참조 = ref020-before-applied (8cbfb23ac).
props 9개 유지 (regionName / userNick / userMailbox / pageTitle / hasRegionAuth / regionId / agentId / userId / userDeposit / userArrearsCount / userArrearsAmount).
호출부 (default.blade.php) 에서 신규 변수 매핑 (page_user_* + login_arrears) 사용 — 발견사항 #1 결정 (b).
-->
<template>
    <div>
        <div class="navi uk-flex uk-flex-left uk-flex-stretch">


            <!-- logo -->
            <a class="logo" href="/">
                <i class="material-icons">home</i>
                GONELO
            </a>

            <!-- 지역 -->
            <a class="region-name" v-if="region" :href="regionUrl">
                <div class="region-flag" v-if="region" :style="flagBackground"></div>
                <i class="material-icons" v-if="! region">location_on</i>
                <i class="material-icons font-size-2rem">{{ transportIcon }}</i>
                {{ region.name }}

            </a>


            <!-- 회원사(닉네임) -->
            <a class="" v-if="userNick" :href="userUrl" :title="'회원사: ' + userNick ">
                <div>
                    <div>
                        <i class="material-icons">home</i>
                        {{ userNick }}
                    </div>
                    <div>
                        <i class="material-icons">mail</i> 내 사서함:
                        {{ userMailbox }}
                    </div>
                </div>
            </a>


            <!-- 예치금 + 미결제 (TASK-046 / TASK-059 — 2026-04-27 디자인 개선)
                 박스 통일 + 라벨 명시 + 인접 표시 + hover 시 가독성 유지 (color 명시)
                 B 옵션: 둘 다 과금내역(billings) 페이지로 이동 (모달/필터만 다름)
            -->
            <a title="예치금 (클릭 시 입금확인요청)" :href="`/region_members/${userId}/payment/billings#bank-deposit-request`"
               class="hdr-money hdr-deposit" :class="depositClass" v-if="userId !== null">
                <span class="hdr-money-label">예치금</span>
                <span class="hdr-money-value">₩<span v-comma-number="userDeposit || 0"></span></span>
            </a>

            <a title="미결제 금액 (클릭 시 미결제 내역)" :href="`/region_members/${userId}/payment/billings?status=9`"
               class="hdr-money hdr-arrears" v-if="userId !== null && userArrearsCount > 0">
                <span uk-icon="icon: warning; ratio: 0.85"></span>
                <span class="hdr-money-label">미결제</span>
                <span class="hdr-money-value">₩<span v-comma-number="userArrearsAmount"></span></span>
                <span class="hdr-money-count">({{ userArrearsCount }}건)</span>
            </a>
        </div>
    </div>

</template>

<script>
import regionAble from "./common/region-able.vue";

export default {
    mixins: [
        regionAble,
    ],
    props: {
        /**
         * (deprecated) region-factory.js 에 정의된 지역캐시정보 객체를 사용함.
         * 지역이름
         */
        regionName: {
            type: String,
            default: null,
        },

        /**
         * 회원사 nick
         */
        userNick: {
            type: String,
            default: null,
        },

        /**
         * 회원사 사서함
         */
        userMailbox: {
            type: String,
            default: null,
        },

        /**
         * 페이지 제목
         */
        pageTitle: {
            type: String,
            default: null,
        },

        /**
         * 지역관리자에대한 권한이 있는지 여부
         */
        hasRegionAuth: {
            type: Boolean,
            default: false,
        },

        /**
         * 지역ID
         */
        regionId: {
            type: Number,
            default: null,
        },

        /**
         * 영업소ID
         */
        agentId: {
            type: Number,
            default: null,
        },

        /**
         * 사용자ID
         */
        userId: {
            type: Number,
            default: null,
        },

        /**
         * 사용자 예치금
         */
        userDeposit: {
            type: Number,
            default: null,
        },

        /**
         * TASK-059: 회원사 미결제 건수
         */
        userArrearsCount: {
            type: Number,
            default: 0,
        },

        /**
         * TASK-059: 회원사 미결제 금액 합계
         */
        userArrearsAmount: {
            type: Number,
            default: 0,
        },
    },
    data: function () {
        return {
            // (Object) 지역정보 객체
            region: this.get_region(this.regionId),
        };
    },
    computed: {

        /**
         * 예치금 클래스
         * @return Object
         */
        depositClass() {
            return {
                plus: this.userDeposit > 0,
                minus: this.userDeposit < 0,
                zero: this.userDeposit === 0,
            };
        },

        /**
         * 국기
         * @return string
         */
        flagBackground() {
            if (!this.region) {
                return null;
            }
            return 'background-image: url("' + this.region.flag32 + '");';
        },

        /**
         * 운송방법 아이콘
         * @return string
         */
        transportBackground() {
            if (!this.region) {
                return null;
            }
            return 'background-image: url("' + this.region.transport_icon32 + '");';
        },

        /**
         * 운송방법 아이콘
         * @return string
         */
        transportIcon() {
            if (!this.region) {
                return null;
            }
            return this.region.transport_material_icon;
        },


        /**
         * 지역을 클릭했을때 이동할 url
         * @return string|null
         */
        regionUrl() {
            if (this.regionId === null) {
                return null;
            }

            if (this.hasRegionAuth) {
                return '/regions/' + this.regionId + '/prods';
            }

            if (this.agentId === null || this.userId === null) {
                return null;
            }

            return '/regions/' + this.regionId + '/agents/' + this.agentId + '/users/' + this.userId + '/prods';

        },

        /**
         * 회원사를 클릭했을때 이동할 url
         * @return string|null
         */
        userUrl() {
            if (this.regionId === null || this.agentId === null || this.userId === null) {
                return null;
            }

            if (this.hasRegionAuth) {
                return '/regions/' + this.regionId + '/agents/' + this.agentId + '/users/' + this.userId + '/prods';
            } else {
                return '/my';
            }


        },
    },
    methods: {},
}
</script>

<style lang="scss" scoped>


.navi {
    background-color: #f3f3f3;

    .material-icons {
        font-size: 1.5em;
    }

    // 아이템들
    & > a, & > div {
        display: flex;
        justify-content: center;
        align-items: center;
    }
}

a {
    padding: 0.25em 0.5em;
    color: #1F2B3D;

    &:hover, &:focus {
        text-decoration: none;
        color: #fff;
        background-color: #1F2B3D;
    }
}

//로고 기본설정
.logo {
    font-size: 1.25em;
    font-family: 'Audiowide', cursive;
}

// 지역
.region-name {
    font-size: 1.25em;

    .region-flag {
        display: inline-block;
        width: 1.75em;
        height: 1.75em;
        vertical-align: middle;

        background-repeat: no-repeat;
        background-position-x: 0;
        background-position-y: 0;
        background-size: contain;
    }

    .transport {
        display: inline-block;
        width: 1.75em;
        height: 1.75em;
        vertical-align: middle;

        background-repeat: no-repeat;
        background-position-x: 0;
        background-position-y: 0;
        background-size: contain;

    }

}

/* TASK-046/059 (2026-04-27 디자인 개선) — 헤더 예치금/미결제 박스 통일
   가독성: hover 시 color 명시 유지 (parent a:hover 영향 무력화)
   레이아웃: 인접 표시 (margin-left 6~8px), gap 4px, 박스 통일감 */
.hdr-money {
    display: inline-flex !important;
    align-items: center;
    gap: 6px;
    padding: 5px 12px;
    margin-left: 8px;
    border-radius: 5px;
    font-size: 1.125em;
    font-weight: 600;
    text-decoration: none;
    line-height: 1.4;
    transition: filter 0.15s, background-color 0.15s;
    white-space: nowrap;

    .hdr-money-label {
        font-size: 0.85em;
        opacity: 0.8;
        font-weight: 500;
    }

    .hdr-money-value {
        letter-spacing: -0.2px;
    }

    .hdr-money-count {
        font-size: 0.85em;
        opacity: 0.9;
        margin-left: 2px;
    }

    &:hover {
        text-decoration: none;
    }
}

/* 예치금 박스 */
.hdr-deposit {
    background: #f3f4f6;
    color: #1f2937;
    border: 1px solid #d1d5db;

    &:hover, &:focus, &:visited {
        color: #1f2937 !important;
        background: #e5e7eb;
        text-decoration: none;
    }
    /* 양수 — 기본 색상 (검정 톤) */
    &.plus {
        color: #1f2937;
        &:hover, &:focus { color: #1f2937 !important; }
    }
    /* 음수 — 빨강 톤 + 굵은 글씨 */
    &.minus {
        color: #b91c1c;
        background: #fef2f2;
        border-color: #fecaca;
        font-weight: 700;
        &:hover, &:focus { color: #991b1b !important; background: #fee2e2; }
    }
    /* 0원 — 회색 톤 (가독성 위해 너무 흐리지 않게) */
    &.zero {
        color: #6b7280;
        background: #f9fafb;
        &:hover, &:focus { color: #4b5563 !important; background: #f3f4f6; }
    }
}

/* 미결제 박스 */
.hdr-arrears {
    background: #fef2f2;
    color: #b91c1c;
    border: 1px solid #fecaca;

    &:hover, &:focus, &:visited {
        color: #991b1b !important;
        background: #fee2e2;
        text-decoration: none;
    }
}


// 작은화면에서 메뉴 작은형태로 표현
@media (max-width: 1349px) {
    a {
        padding: 0.125em 0.25em;
    }
    .region-name {
        font-size: 1em;
    }
    .region-flag {
        width: 1.25em;
        height: 1.25em;
    }
}

</style>
